import * as ActionTypes from './actionTypes';
import { slugFor } from 'polyphony/gutenberg';

const makeInitialState = () => {
    return {
        ...window.initialState,
        windowHeight: innerHeight,
        windowWidth: innerWidth,
        windowX: pageXOffset,
        windowY: pageYOffset,
        focusMode: 'mouse',
        hashScrollOffset: 0, // # px to scroll in addition to the y-offset of any node referenced by ID in the URL hash
        loading: true, // are we loading the initial/primary content?
        loadingMore: false, // are we loading more content (i.e. infinite scroll)?
        loadingReplacement: false, // are we loading replacement content?
        queryPath: null, // the currently rendered query (a path)
        extraQueryVars: {}, // extra query args passed to backend (object)
        error: null, // TODO: handle this better.
        blocks: {}, // block slug => "Block" React component
        errorPageComponent: null, // render an error page
        notFoundComponent: null, // render a 404 page
        loadingIndicator: null, // render a loading indicator
        customizerControls: {},
        taxonomy: { // Components for rendering the terms in a taxonomy
            /*my_taxonomy: {
                TaxonomyArchive: MyComponent // render an "archive" of terms
            }*/
            // term slug => dict
        },
        post_type: {
            /*my_post_type: {
                Post: MyComponent, // render a singular post
                Archive: MyComponent // render an archive of posts
            }*/
            // post_type => dict
        }
    };
};

export const root = (state = makeInitialState(), { type, ...xsAction }) => {
  switch (type) {
    case ActionTypes.LOAD_CONTENT_STARTED: {
        const { replace, ...xs } = xsAction;
        if (replace && !state.loading) { // if we're not loading, replace.
            return {...state, posts: [], terms: [], error: null, loading: false, loadingMore: false, loadingReplacement: true, ...xs};
        }
        // if we're either not going to replace, or going to replace currently loading content
        return {...state, posts: [], terms: [], loading: true, loadingMore: false, loadingReplacement: false, error: null, ...xs};
    }
    case ActionTypes.LOAD_CONTENT_FINISHED: {
        const { json, error, requestId } = xsAction;
        if (state.requestId !== requestId) {
            return {...state};
        }
        return {...state, loading: false, loadingMore: false, loadingReplacement: false, requestId: null, error, ...json};
    }
    case ActionTypes.LOAD_MORE_CONTENT_STARTED: {
        if (state.loading) {
            return {...state};
        }
        return {...state, loading: false, loadingReplacement: false, loadingMore: true, error: null, ...xsAction};
    }
    case ActionTypes.LOAD_MORE_CONTENT_FINISHED: {
        const { json, error, requestId } = xsAction;
        if (state.requestId !== requestId) {
            return {...state};
        }

        let posts = state.posts.concat(json.posts);
        let terms = state.terms.concat(json.terms);
        let pagination = json.pagination;
        return {...state, loadingMore: false, requestId: null, error, posts, terms, pagination };
    }

    case ActionTypes.SET_STATE: {
        return {...state, ...xsAction.state};
    }
    case ActionTypes.SET_CONTENT_WRAPPER: {
        return {...state, contentWrapper: xsAction.contentWrapper};
    }
    case ActionTypes.ADD_BLOCK: {
        let b = xsAction.block;
        b.slug = slugFor(b); // Because regexes are expensive
        return {...state, blocks: {...state.blocks, [b.slug]: b}};
    }
    case ActionTypes.REGISTER_POST_TYPE: {
        const {post_type: key, Post:P, Archive:A} = xsAction;

        let v = {};
        if (P) v.Post = P;
        if (A) v.Archive = A;

        return {...state, post_type: {...state.post_type, [key]: {...state.post_type[key], ...v}}};
    }
    case ActionTypes.REGISTER_ERROR_PAGE: {
        return {...state, errorPageComponent: xsAction.component};
    }
    case ActionTypes.REGISTER_NOT_FOUND_PAGE: {
        return {...state, notFoundComponent: xsAction.component};
    }
    case ActionTypes.REGISTER_LOADING_INDICATOR: {
        return {...state, loadingIndicator: xsAction.component};
    }
    case ActionTypes.REGISTER_TAXONOMY: {
        const {taxonomy, Archive: TaxonomyArchive} = xsAction;
        return {...state, taxonomy: {...state.taxonomy, [taxonomy]: {TaxonomyArchive}}};
    }
    case ActionTypes.REGISTER_CUSTOMIZER_CONTROL: {
        const {key, Component} = xsAction;
        return {...state, customizerControls: {...state.customizerControls, [key]: Component}};
    }
    case ActionTypes.SET_HASH_SCROLL_OFFSET: {
        const {offset} = xsAction;
        return {...state, hashScrollOffset: offset};
    }
    case ActionTypes.SET_FOCUS_MODE: {
        const {focusMode} = xsAction;
        return {...state, focusMode};
    }
    case ActionTypes.SET_WINDOW_SIZE: {
        const {width, height} = xsAction;
        return {...state, windowHeight: height, windowWidth: width};
    }
    case ActionTypes.SET_WINDOW_POSITION: {
        const {x, y} = xsAction;
        return {...state, windowX: x, windowY: y};
    }
    default:                      return state;
  }
};

